var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoingWell4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 83,
    viewBox: "0 0 100 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.118 51.1761C47.7195 51.9978 47.7511 52.9645 48.2002 53.7602L54.581 64.6935C55.121 65.6205 55.0682 66.777 54.4469 67.6529C53.8501 68.5442 52.7937 69.01 51.733 68.8577L39.1939 67.2027C38.7565 67.1411 38.3116 67.1847 37.8909 67.3246L37.2462 67.5596C37.0348 67.6744 36.8419 67.8255 36.682 68.0078L28.156 77.3703C27.7304 77.8218 27.1742 78.1296 26.5623 78.2476C25.0569 78.4944 23.6282 77.4952 23.3431 75.9957L21.1943 63.5199C21.0234 62.6147 20.4238 61.8496 19.5866 61.4675L7.96168 56.2724C6.9892 55.8372 6.35791 54.8816 6.34197 53.8175C6.31738 52.7593 6.88038 51.7752 7.8065 51.2625L19.0044 45.238C19.8698 44.8175 20.4602 43.9825 20.5698 43.0262L21.8864 30.4461C21.9234 30.1632 22.003 29.8862 22.1281 29.6304L22.2815 29.3859C22.3482 29.2214 22.4394 29.0723 22.5518 28.937L22.7764 28.7474L23.1201 28.4334L24.1216 28.0684C25.0499 27.8352 26.0324 28.0834 26.7353 28.7327L35.8898 37.4423C36.554 38.0815 37.4907 38.3518 38.3924 38.1714L50.8406 35.5773C51.8918 35.3558 52.9782 35.7414 53.6557 36.5724C54.315 37.4127 54.4277 38.5574 53.9456 39.512L48.118 51.1761Z",
    fill: "url(#paint0_linear_112_909)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_112_909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1508 49.3388C76.1464 49.9186 75.4908 50.9575 75.3958 52.114L74.3127 68.1549C74.2198 69.5142 73.3402 70.6924 72.0629 71.1705C70.8004 71.6822 69.3578 71.4192 68.3513 70.5031L56.3486 59.8279C55.9326 59.4515 55.4338 59.1803 54.8919 59.0275L54.0467 58.8152C53.7426 58.7852 53.4321 58.8066 53.1341 58.8843L37.4991 62.6512C36.7299 62.8226 35.9259 62.7499 35.1986 62.4379C33.4401 61.6246 32.6502 59.5561 33.419 57.7765L40.0503 43.1297C40.5157 42.0563 40.4306 40.8247 39.8227 39.8264L31.3037 26.081C30.5915 24.9305 30.6088 23.476 31.3503 22.346C32.0786 21.216 33.3717 20.5827 34.7107 20.7036L50.7759 22.3498C51.9853 22.5244 53.201 22.0673 53.9976 21.1402L64.3464 8.8532C64.5869 8.58208 64.868 8.34766 65.1817 8.16788L65.5173 8.02009C65.7046 7.89475 65.9067 7.80296 66.1213 7.74083L66.4925 7.7015L67.0776 7.61641L68.3906 7.94634C69.5327 8.36263 70.3887 9.32374 70.6649 10.5072L74.0824 26.187C74.3251 27.3322 75.1172 28.2839 76.1937 28.7368L91.1288 34.8802C92.3917 35.3965 93.2591 36.576 93.3792 37.9324C93.4735 39.2857 92.7762 40.5694 91.5892 41.2294L77.1508 49.3388Z",
    fill: "url(#paint1_linear_112_909)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8115 68.189L74.8116 68.1886L75.8941 52.1549C75.8942 52.1538 75.8943 52.1526 75.8944 52.1515C75.977 51.1601 76.539 50.2704 77.3983 49.7733C77.3992 49.7728 77.4 49.7723 77.4008 49.7718L91.8321 41.6664C91.8325 41.6662 91.8328 41.666 91.8332 41.6658C93.1888 40.9116 93.9857 39.4446 93.8779 37.8977L93.878 37.8977L93.8772 37.8884C93.7407 36.3462 92.7548 35.0051 91.3187 34.4177C91.3185 34.4176 91.3183 34.4175 91.318 34.4174L76.3876 28.2759C76.387 28.2756 76.3865 28.2754 76.3859 28.2752C75.4601 27.8851 74.7799 27.0666 74.5715 26.0833L74.5709 26.0805L71.1534 10.4007L71.1535 10.4007L71.1518 10.3936C70.837 9.04475 69.8616 7.95033 68.5618 7.47657C68.5456 7.47067 68.5291 7.46561 68.5124 7.46141L67.1994 7.13149C67.1361 7.11557 67.0703 7.11222 67.0056 7.12162L66.4302 7.2053L66.0686 7.24361C66.0393 7.24671 66.0104 7.25238 65.9822 7.26056C65.7355 7.332 65.4992 7.43667 65.2778 7.57923L64.9802 7.71029C64.9641 7.71738 64.9484 7.72531 64.9331 7.73406C64.5686 7.94291 64.246 8.21297 63.9724 8.52137L63.9722 8.52126L63.9639 8.5311L53.6184 20.8143C53.6179 20.8149 53.6173 20.8155 53.6168 20.8161C52.9313 21.6126 51.8863 22.005 50.8473 21.855C50.8405 21.854 50.8337 21.8531 50.8268 21.8524L34.7616 20.2062L34.7616 20.2062L34.7556 20.2056C33.2315 20.068 31.7601 20.7886 30.9312 22.0734C30.0837 23.3663 30.0647 25.0296 30.8786 26.3442L30.8787 26.3444L39.3956 40.0865C39.396 40.0871 39.3963 40.0876 39.3967 40.0882C39.9184 40.9462 39.9919 42.0043 39.5931 42.9272L32.9635 57.5702L32.9634 57.5702L32.96 57.5782C32.0837 59.6066 32.9839 61.9645 34.9888 62.8917L34.9887 62.8919L35.0015 62.8974C35.8259 63.2511 36.737 63.3333 37.6079 63.1392L37.6079 63.1393L37.6163 63.1373L53.2512 59.3703L53.2513 59.3704L53.2602 59.3681C53.4871 59.309 53.7257 59.29 53.9626 59.3096L54.7628 59.5107C55.2304 59.6435 55.6579 59.8773 56.0131 60.1987L56.0163 60.2015L68.0147 70.8729C68.0155 70.8736 68.0162 70.8743 68.017 70.875C69.1629 71.9163 70.8047 72.2171 72.2445 71.6364C73.7016 71.0882 74.7054 69.7422 74.8115 68.189Z",
    stroke: "url(#paint2_linear_112_909)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_112_909",
    x: 5.78162,
    y: -17.3835,
    width: 112.606,
    height: 113.812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_112_909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_112_909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_909",
    x1: 23.7298,
    y1: 28.1319,
    x2: 40.3866,
    y2: 73.8317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_112_909",
    x1: 67.9333,
    y1: 7.73389,
    x2: 52.8786,
    y2: 67.6468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_112_909",
    x1: 44.9624,
    y1: 9.39917,
    x2: 81.8847,
    y2: 73.0546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoingWell4);
export default __webpack_public_path__ + "static/media/doing-well4.7e0ac75537626fb1b16479d98ab80f08.svg";
export { ForwardRef as ReactComponent };